import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M19 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6M20.34 12.72h-3.31c-.93 0-1.76.52-2.18 1.34l-.8 1.58c-.19.38-.57.61-.99.61H9.95c-.29 0-.72-.06-.99-.62l-.79-1.57a2.43 2.43 0 0 0-2.18-1.35H2.66c-.36.01-.66.31-.66.67v3.09C2 19.94 4.07 22 7.53 22h7.96c3.26 0 5.27-1.79 5.51-4.96v-3.66c0-.36-.3-.66-.66-.66" }, null, -1),
    _createElementVNode("path", { d: "M21 10.4v.93c-.21-.07-.43-.11-.66-.11h-3.31c-1.5 0-2.85.83-3.51 2.17l-.7 1.37h-2.63l-.68-1.36a3.91 3.91 0 0 0-3.52-2.18H2.66c-.23 0-.45.04-.66.11V8.52C2 5.47 4.47 3 7.52 3h6.08a1 1 0 0 1 .98 1.2c-.16.8-.09 1.67.3 2.59a4.5 4.5 0 0 0 2.33 2.33c.92.39 1.79.46 2.59.3a1 1 0 0 1 1.2.98" }, null, -1)
  ]))]))
}
export default { render: render }